import {Breakpoints} from '@config/breakpoints';

export interface IViewportInfo {
    width: number;
    height: number;
    type: 'mobile' | 'tablet' | 'desktop';
}

export const getViewportInfo = (): IViewportInfo => {
    const width = window.innerWidth;
    const height = window.innerHeight;

    let type: 'mobile' | 'tablet' | 'desktop';

    if (width < Breakpoints.TABLET) {
        type = 'mobile';
    } else if (width >= Breakpoints.TABLET && width < 1024) {
        type = 'tablet';
    } else {
        type = 'desktop';
    }

    return {
        width,
        height,
        type,
    };
};
